import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The "NO DATA FOUND" panel shown in place of a list when a search matches nothing, matching
 * the collection screen's empty-search treatment. Screens keep their own empty state for
 * "there is genuinely no data" and render this one only while a search term is active.
 */
@Component({
  selector: 'cygov-no-data-found',
  templateUrl: './no-data-found.component.html',
  styleUrls: ['./no-data-found.component.scss'],
  standalone: false,
})
export class NoDataFoundComponent {
  @Input() message = 'NO DATA FOUND';
  @Input() clearLabel = 'Clear Search';
  @Input() showClear = true;
  @Output() clearSearch = new EventEmitter<void>();
}
